var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { MapContainer, TileLayer, Popup, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import MarkerClusterGroup from "react-leaflet-cluster";
import Leaflet from 'leaflet';
import { FormatTooltip } from '../general';
//@ts-ignore
import icon from 'leaflet/dist/images/marker-icon.png';
var DefaultIcon = Leaflet.icon({
    iconUrl: icon,
    iconSize: [20, 35],
    iconAnchor: [12, 41],
    popupAnchor: [-2, -36]
});
Leaflet.Marker.prototype.options.icon = DefaultIcon;
function BubbleMap(props) {
    var markers = props.markers, height = props.height;
    return (_jsx("div", __assign({ style: { height: height.toString() + 'px' } }, { children: _jsxs(MapContainer, __assign({ center: [51.510357, -0.116773], zoom: 6, scrollWheelZoom: true, className: "tol-map" }, { children: [_jsx(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }), _jsx(MarkerClusterGroup, __assign({ chunkedLoading: true }, { children: markers.map(function (marker, index) {
                        return (_jsx(Marker, __assign({ position: marker.geometry.coordinates }, { children: Object.keys(marker.properties).length > 0 && (_jsx(Popup, __assign({ className: 'tol-map-popup' }, { children: _jsx(FormatTooltip, { contents: marker.properties }) }))) }), index));
                    }) }))] })) })));
}
export default BubbleMap;
